import { render } from "./ModalWarehouse.vue?vue&type=template&id=8f03e6e2"
import script from "./ModalWarehouse.vue?vue&type=script&lang=js"
export * from "./ModalWarehouse.vue?vue&type=script&lang=js"

import "./ModalWarehouse.vue?vue&type=style&index=0&id=8f03e6e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__